import ShipbobAppSettings from '@/appSettings/appSetting'

export const SetChatBotMetadata = (loggedInUser) => {
  window.duet.setUserId(loggedInUser?._userId)

  window.duet.setMetadata({
    email: loggedInUser?._email,
    user_id: loggedInUser?._userId
  })

  window.duet.updateStyle({
    margin: '-15px'
  })
}

export function InitializeChatBot (loggedInUser) {
  const s = document.createElement('script')
  const scriptSrc = ShipbobAppSettings.DecagonChatBotUrl
  s.setAttribute('src', scriptSrc)
  s.onload = function () {
    SetChatBotMetadata(loggedInUser)
  }
  document.body.appendChild(s)
}
